<div class="connect-claude">
  <button
    type="button"
    class="btn btn--sm"
    [disabled]="!domain"
    [attr.aria-expanded]="open"
    aria-controls="connect-claude-panel"
    (click)="toggle()"
  >
    Connect Claude
  </button>

  <div class="connect-claude__panel" id="connect-claude-panel" *ngIf="open">
    <p class="field__hint" role="status" *ngIf="link === undefined && busy">Checking for a link…</p>

    <ng-container *ngIf="link === null">
      <p class="field__hint">
        A private link that lets your Claude read this site's review queue. Read-only: Claude cannot change anything here.
      </p>
      <div class="connect-claude__row">
        <button
          type="button"
          class="btn btn--sm btn--accent"
          [class.btn--loading]="busy"
          [disabled]="busy"
          [attr.aria-busy]="busy"
          (click)="create()"
        >
          Create link
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="link">
      <div class="field">
        <span class="field__label">Claude connector link for {{ link.domain }}</span>
        <span class="connect-claude__url">{{ link.connectorUrl }}</span>
        <p class="field__hint">
          In Claude: Settings → Connectors → Add custom connector, then paste it.
          Anyone with this link can read the queue — share it only with your team.
          <ng-container *ngIf="link.expiresAt">Expires {{ link.expiresAt | date: 'd MMM y' }}.</ng-container>
        </p>
      </div>

      <div class="connect-claude__row" *ngIf="!confirmingRevoke">
        <button type="button" class="btn btn--sm" (click)="copy()">Copy link</button>
        <button type="button" class="btn btn--sm btn--quiet" (click)="confirmingRevoke = true; notice = null">Revoke…</button>
      </div>

      <div class="connect-claude__row" role="group" aria-label="Confirm revoking the link" *ngIf="confirmingRevoke">
        <span class="field__hint">Claude loses access on its next question.</span>
        <button
          type="button"
          class="btn btn--sm btn--danger"
          [class.btn--loading]="busy"
          [disabled]="busy"
          (click)="revoke()"
        >
          Revoke link
        </button>
        <button type="button" class="btn btn--sm btn--quiet" [disabled]="busy" (click)="confirmingRevoke = false">Keep it</button>
      </div>
    </ng-container>

    <p class="field__hint" role="status" *ngIf="notice">{{ notice }}</p>
    <p class="field__error" role="alert" *ngIf="error">{{ error }}</p>
  </div>
</div>
